<template>
  <div id="cte-fiscal">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="1" class="pa-2">
      <v-card-title class="header d-flex justify-space-between align-center">
        <h1 class="pa-0">Ctes</h1>
        <div class="d-flex">
          <v-btn
            elevation="2"
            :loading="isDownloadXmlFilterLoading"
            :disabled="!hasFilters"
            @click="downloadXmlFilters()"
            class="mx-2"
            color="info"
            large
          >
            Download XML Filtrados</v-btn
          >
          <v-btn
            :loading="isDownloadXmlLoading"
            :disabled="!selectedCheckbox.length"
            @click="downloadXml()"
            elevation="2"
            class="mx-2"
            color="info"
            large
          >
            Download XML Selecionados
          </v-btn>
        </div>
      </v-card-title>

      <v-expansion-panels accordion class="mt-2 mb-10 px-4">
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2 pb-1">
              <v-col cols="12" md="4" class="pb-0">
                <h5>Data de Autorização</h5>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="4" class="pb-0">
                <h5>Data de Importação</h5>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="4" class="pb-0">
                <h5>Número Cte</h5>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedAuthorizationDateInitial"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="authorizationDateInitial" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedAuthorizationDateEnd"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="authorizationDateEnd" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedImportDateInitial"
                      label="Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="importDateInitial" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-menu
                  ref="menu4"
                  v-model="menu4"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedImportDateEnd"
                      label="Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="importDateEnd" locale="pt-br"></v-date-picker>
                </v-menu>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="2" class="pt-0">
                <v-text-field v-model="numberCteInitial" v-mask="'#########'" label="Início"></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pt-0">
                <v-text-field
                  v-model="numberCteEnd"
                  v-mask="'#########'"
                  label="Fim"
                  :rules="[validateNumber]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="senderId"
                  :items="senders"
                  label="Embacador"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="key"
                  label="Chave CTE"
                  v-mask="'############################################'"
                  type="text"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-select v-model="hasXml" label="Possui XML" :items="hasXmlOptions"></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-combobox
                  v-model="boardingNumbers"
                  :search-input.sync="boardingNumbersInput"
                  append-icon=""
                  label="Número embarque externo"
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @keydown.native="filterInput"
                  @change="saveBoardingNumbers"
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="8" class="d-flex justify-end align-center">
                <v-btn @click="cleanFilter()" :disabled="!hasFilters" elevation="2" color="red" class="mx-2 text-white">
                  Limpar Filtros
                </v-btn>
                <v-btn
                  :loading="isCtesLoading"
                  :disabled="!hasFilters"
                  @click="seach()"
                  elevation="2"
                  color="green"
                  class="text-white"
                >
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="table mt-10 p-relative">
        <table-title-row :columnsOptions="columnsOptions"></table-title-row>
        <v-progress-linear v-if="isCtesLoading" indeterminate color="primary"></v-progress-linear>
        <div v-if="ctes.length !== 0">
          <template v-for="(cteNode, cteIndex) in ctes">
            <div :key="cteNode.data.id">
              <table-body-row
                :node="cteNode"
                :nodeIndex="cteIndex"
                :columns="columnsCtes"
                :lengthDataToTruncate="22"
                type="Ctes"
                enableCheckbox
                :checkbox-disabled="!cteNode.data.importDate"
                :selectedCheckbox="selectedCheckbox"
                @changeCheckbox="changeSelectedCheckbox"
              >
              </table-body-row>
            </div>
          </template>
        </div>
        <div class="table mt-10 p-relative" v-else>Nenhum resultado encontrado</div>
        <div class="mt50"></div>
        <div class="d-flex justify-space-between">
          <v-pagination
            v-model="pageNumber"
            :length="totalPages"
            @input="changePageNumber"
            :total-visible="7"
          ></v-pagination>
          <items-per-page-selector class="pl-5" @change="changePageSize"></items-per-page-selector>
        </div>
      </div>
    </v-card>
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadCrumb from '@/components/BreadCrumb.vue';
import TableTitleRow from '@/components/Table/Table-Title-Row.vue';
import TableBodyRow from '@/components/Table/Table-Body-Row.vue';
import ItemsPerPageSelector from '@/components/ItemsPerPageSelector.vue';
import maskData from '@/utils/maskData';
import changeCheckbox from '@/utils/changeSelectedCheckbox';
import MessagesError from '@/components/MessagesError.vue';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';
import comboboxFormatter from '@/utils/comboboxFormatter';
import allowedChars from '@/utils/allowedChars';

export default {
  name: 'Ctes',
  components: {
    BreadCrumb,
    TableTitleRow,
    TableBodyRow,
    ItemsPerPageSelector,
    MessagesError
  },
  data: () => ({
    isCtesLoading: false,
    isDownloadXmlLoading: false,
    isDownloadXmlFilterLoading: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    key: null,
    numberCteInitial: null,
    numberCteEnd: null,
    importDateInitial: null,
    importDateEnd: null,
    authorizationDateInitial: null,
    authorizationDateEnd: null,
    senderId: null,
    hasXml: null,
    boardingNumbers: [],
    boardingNumbersInput: '',
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Fiscal',
        disabled: true
      },
      {
        text: 'Ctes',
        disabled: true
      }
    ],
    columnsOptions: [
      {
        value: 'senderName',
        text: 'EMBARCADOR'
      },
      {
        value: 'accessKeyCte',
        text: 'CHAVE CTE'
      },
      {
        value: 'number',
        text: 'NÚMERO CTE'
      },
      {
        value: 'authorizationDate',
        text: 'DATA AUTORIZAÇÃO'
      },
      {
        value: 'responsibleUserName',
        text: 'IMPORTADO POR'
      },
      {
        value: 'importDate',
        text: 'DATA IMPORTAÇÃO'
      }
    ],
    columnsCtes: ['senderName', 'accessKeyCte', 'number', 'authorizationDate', 'responsibleUserName', 'importDate'],
    hasXmlOptions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false }
    ],
    pageNumber: 1,
    pageSize: 10,
    totalPages: 0,
    ctes: [],
    senders: [],
    selectedCheckbox: [],
    errors: [],
    error500: null,
    errorsType: 'error'
  }),

  computed: {
    formattedImportDateInitial() {
      let date = this.importDateInitial;
      return this.formatDate(date);
    },
    formattedImportDateEnd() {
      let date = this.importDateEnd;
      return this.formatDate(date);
    },

    formattedAuthorizationDateInitial() {
      let date = this.authorizationDateInitial;
      return this.formatDate(date);
    },

    formattedAuthorizationDateEnd() {
      let date = this.authorizationDateEnd;
      return this.formatDate(date);
    },

    validateNumber() {
      const valueInitial = Number(this.numberCteInitial);
      const valueEnd = Number(this.numberCteEnd);

      if (!valueInitial || !valueEnd) return true;

      return valueEnd >= valueInitial || 'O campo deve ser menor que o campo Início';
    },

    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    },

    hasFilters() {
      if (
        this.importDateInitial ||
        this.importDateEnd ||
        this.authorizationDateInitial ||
        this.authorizationDateEnd ||
        this.senderId ||
        this.key ||
        this.numberCteInitial ||
        this.numberCteEnd ||
        this.hasXml !== null ||
        this.boardingNumbers.length
      ) {
        return true;
      }
      return false;
    }
  },

  created() {
    this.filterTheLastThirtyDays();
    this.fetchAllCtes();
    this.getAllSenders();
  },

  methods: {
    ...mapActions('AccountsReceivableStore', ['getSenders']),
    ...mapActions('ImportXmlStore', ['fetchListCtes', 'downloadCteXml', 'downloadCteXmlFilter']),

    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays;
      this.authorizationDateInitial = thirtyDayAgo;
      this.authorizationDateEnd = currentDay;
    },

    async fetchAllCtes() {
      try {
        this.isCtesLoading = true;

        const filters = this.getFilters();
        const { data, totalPages, totalRecords } = await this.fetchListCtes(filters);
        this.totalPages = totalPages;
        this.totalRecords = totalRecords;

        const ctes = data.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              importDate: item.importDate ? this.transformDate(item.importDate) : null,
              authorizationDate: this.transformDate(item.authorizationDate)
            },
            type: 'Ctes',
            selected: false
          };
        });

        this.ctes = ctes;
      } catch (err) {
        console.error(err);
      } finally {
        this.isCtesLoading = false;
      }
    },

    async getAllSenders() {
      try {
        this.senders = await this.getSenders();
      } catch (error) {
        console.error(error);
      }
    },

    async downloadXml() {
      try {
        this.isDownloadXmlLoading = true;

        const cteIds = this.selectedCheckbox.map((cte) => cte.id);
        const payload = { cteIds };

        const data = await this.downloadCteXml(payload);
        if (data.success) {
          FeedbackMessageHandler.setFeedbackMessage(this, 'Exportação dos XMLs criado com sucesso!');
          this.$router.push('/xmls-ctes-export');
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isDownloadXmlLoading = false;
      }
    },

    async downloadXmlFilters() {
      try {
        this.isDownloadXmlFilterLoading = true;

        const filters = this.getFilters();
        const data = await this.downloadCteXmlFilter(filters);
        if (data.success) {
          FeedbackMessageHandler.setFeedbackMessage(this, 'Exportação dos XMLs criado com sucesso!');
          this.$router.push('/xmls-ctes-export');
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isDownloadXmlFilterLoading = false;
      }
    },

    changeSelectedCheckbox(item, children) {
      this.selectedCheckbox = changeCheckbox(this.selectedCheckbox, item, children);
    },

    changePageNumber(pageNumber) {
      this.pageNumber = pageNumber;
      this.fetchAllCtes();
    },

    async changePageSize(value) {
      this.pageSize = value;
      this.pageNumber = 1;
      await this.fetchAllCtes();
    },

    formatDate(d) {
      if (d === null) return d;
      let dateObj = new Date(`${d}T00:00:00`);
      return dateObj.toLocaleDateString('pt-BR');
    },

    transformDate(date) {
      return maskData(date);
    },

    seach() {
      this.pageNumber = 1;
      this.fetchAllCtes();
    },

    setClearErrorTimer() {
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    },

    filterInput(event) {
      return allowedChars(event, /[0-9,.;/]/);
    },

    saveBoardingNumbers(value) {
      this.boardingNumbers = comboboxFormatter(value);
    },

    getFilters() {
      return {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        importDateInitial: this.importDateInitial,
        importDateEnd: this.importDateEnd,
        authorizationDateInitial: this.authorizationDateInitial,
        authorizationDateEnd: this.authorizationDateEnd,
        numberCteInitial: this.numberCteInitial,
        numberCteEnd: this.numberCteEnd,
        accessKey: this.key,
        senderId: this.senderId,
        hasXml: this.hasXml,
        boardingNumbers: this.boardingNumbers
      };
    },

    cleanFilter() {
      this.importDateInitial = null;
      this.importDateEnd = null;
      this.senderId = null;
      this.key = null;
      this.numberCteInitial = null;
      this.numberCteEnd = null;
      this.authorizationDateInitial = null;
      this.authorizationDateEnd = null;
      this.hasXml = null;
      this.boardingNumbers = [];

      this.pageNumber = 1;
      this.fetchAllCtes();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}

::v-deep .v-data-table-header tr th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}

::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 4px;
      display: inline-block;
    }
  }
}
</style>
